/**
 * Bunny AI Gateway
 * Security-first AI gateway. One API. Every model. Total protection. All `/v1/_*` endpoints are transparently proxied to the underlying AI Gateway runtime. Use a valid API key in the `Authorization` header.
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreatedAt } from './created-at';
import { Expires } from './expires';
import { UpdatedAt } from './updated-at';

export interface ApiKeyItem {
  key_id: string;
  name?: string | null;
  user_id?: string | null;
  team_id?: string | null;
  models?: string[];
  spend?: number | null;
  max_budget?: number | null;
  expires?: Expires | null;
  status: ApiKeyItem.StatusEnum;
  metadata?: object | null;
  tpm_limit?: number | null;
  rpm_limit?: number | null;
  max_parallel_requests?: number | null;
  region?: string;
  created_at?: CreatedAt | null;
  updated_at?: UpdatedAt | null;
}
export namespace ApiKeyItem {
  export type StatusEnum = 'active' | 'blocked';
  export const StatusEnum = {
    active: 'active' as StatusEnum,
    blocked: 'blocked' as StatusEnum,
  };
}
